import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { STColumn, STComponent } from '@delon/abc';
import { SFSchema } from '@delon/form';

@Component({
  selector: 'app-log-oplog',
  templateUrl: './oplog.component.html'
})
export class LogOplogComponent implements OnInit {
  url = `api/v1/log/oplog/list`;
  searchSchema: SFSchema = {
    properties: {
      id: {
        type: 'string',
        title: 'æ¥å¿ç¼å·'
       },
      userId: {
        type: 'string',
        title: 'ç¨æ·ç¼å·'
      },
     //  succeed: {
     //    type: 'number',
     //    title: 'æä½ç»æ'
     //  },
     ip: {
        type: 'string',
        title: 'ip'
      }
      // ,
      // recordType: {
     //    type: 'date',
     //    title: 'æä½ç±»å'
     //  },
     //  recordId: {
     //    type: 'string',
     //    title: 'id'
     //  },
     //  opType: {
     //    type: 'string',
     //    title: 'æä½ç±»å'
     //  },
     //  msgCode: {
     //    type: 'string',
     //    title: 'msgCode'
     //  },
     //  message: {
     //    type: 'string',
     //    title: 'message'
     //  },
     //  optTime: {
     //    type: 'date',
     //    title: 'æä½æ¶é´'
     //  }
    }
  };
  @ViewChild('st') st: STComponent;
  columns: STColumn[] = [
    { title: 'æ¥å¿ç¼å·', index: 'id' },
    { title: 'ç¨æ·ç¼å·', index: 'userId' },
    { title: 'ip', index: 'ip' },
    { title: 'id', index: 'recordId' },
    { title: 'ç±»å', index: 'recordType' },
    { title: 'æä½ç±»å', index: 'opType' },
    { title: 'msgCode', index: 'msgCode' },
    { title: 'message', index: 'message' },
    { title: 'æä½ç»æ', type: 'number', index: 'succeed' },
    { title: 'æä½æ¶é´', type: 'date', index: 'optTime' }
  ];

  constructor(private http: _HttpClient, private modal: ModalHelper) { }

  ngOnInit() { }

  // add() {
  //   this.modal
  //     .createStatic(LogOplogEditComponent, { i: { id: 0 } })
  //     .subscribe(() => this.st.reload());
  // }

}
